import { FormDialog } from 'components/dialog/form'
import { SearchsSenmoniResult, useEditSearchsSenmoni } from 'interface/search/senmoni'
import { useSearchsSenmoniForm, SearchsSenmoniForm } from '../form'

type EditSearchsSenmoniDialogProps = {
  searchId: number
  senmoni: SearchsSenmoniResult
  onSubmit: (result: SearchsSenmoniResult) => void
  onClose: () => void
}
export const EditSearchsSenmoniDialog = ({
  searchId,
  senmoni,
  onSubmit,
  onClose
}: EditSearchsSenmoniDialogProps) => {
  const [postState, submit] = useEditSearchsSenmoni(searchId, senmoni.searchsSenmoniId, { onEditted: onSubmit })
  const form = useSearchsSenmoniForm({ searchId, data: senmoni, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title={senmoni.senmoniName ?? ''}
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsSenmoniForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
